module.exports = __webpack_public_path__ + "img/20.0dad8e45.jpg";